// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
// Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: "pdx-web-v2",
  storageBucket: "pdx-web-v2.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialise Firebase
export const firebaseApp = initializeApp(firebaseConfig);
// export const auth = getAuth(firebaseApp);
// export const db   = getFirestore(firebaseApp);
export const fns = getFunctions(firebaseApp, "europe-west2");

/* ---------- Only when running locally ---------- */
if (
  process.env.REACT_APP_FIREBASE_USE_EMULATORS === "true" &&
  window.location.hostname === "localhost"
) {
  // connectAuthEmulator(auth, 'http://localhost:9099');
  // connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(fns, "localhost", 5001);
  console.info("[Firebase] connected to local emulators");
}
